import { render, staticRenderFns } from "./leader_activeReport.vue?vue&type=template&id=b31cf42e&scoped=true"
import script from "./leader_activeReport.vue?vue&type=script&lang=js"
export * from "./leader_activeReport.vue?vue&type=script&lang=js"
import style0 from "./leader_activeReport.vue?vue&type=style&index=0&id=b31cf42e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31cf42e",
  null
  
)

export default component.exports